import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import { getFeedbacks } from '../../../services/FeedBackService';
import * as XLSX from 'xlsx';
import './index.css';
import DownloadEstadisticasExcel from "../downloadEstadistica";
import { escapeHtml } from '../../../utils/escapeHtml';

const CustomerReview = () => {
  const [feedbacks, setFeedbacks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFeedbacks = async () => {
      try {
        const data = await getFeedbacks();
        setFeedbacks(data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error('Error al obtener los feedbacks:', error);
      }
    };

    fetchFeedbacks();
  }, []);

  // Crear puntos de datos que incluyen fecha, calificación y comentario
  const dataPoints = feedbacks.map(fb => ({
    x: fb.fechaCreacion, // fecha
    y: fb.calificacion,  // calificación
    comment: fb.comentario, // comentario
  }));

  const data = {
    series: [
      {
        name: "Calificación",
        data: dataPoints,
      },
    ],
    options: {
      chart: {
        type: "area",
        height: "auto",
      },
      fill: {
        colors: ["#fff"],
        type: "gradient",
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
        colors: ["#ff929f"],
      },
      tooltip: {
        x: {
          format: "dd/MM/yyyy",
        },
        custom: function({ series, seriesIndex, dataPointIndex, w }) {
          const dataPoint = w.globals.initialSeries[seriesIndex].data[dataPointIndex];
          const date = new Date(dataPoint.x).toLocaleString();
          const rating = dataPoint.y;
          const comment = escapeHtml(dataPoint.comment || 'Sin comentario');

          return `
            <div class="tooltip" style="padding: 10px;">
              <strong>Fecha:</strong> ${date}<br/>
              <strong>Calificación:</strong> ${rating}<br/>
              <strong>Comentario:</strong> ${comment}
            </div>
          `;
        }
      },
      grid: {
        show: false,
      },
      xaxis: {
        type: "datetime",
      },
      yaxis: {
        show: true,
        min: 0,
        max: 5,
        tickAmount: 5,
      },
      toolbar: {
        show: true,
      },
    },
  };

  if(loading){
    return(
      <div style={{ display:'flex', justifyContent: 'center', alignItems: 'center'}}>
        <h2 style={{ fontWeight: 'bold'}}>Cargando...</h2>
      </div>
    )
  }else{
      return (
        <div className="customer-review-container">
          <Chart options={data.options} series={data.series} type="area"  />
          <DownloadEstadisticasExcel/>
        </div>
      );
  }
};

export default CustomerReview;
